export default "__VITE_ASSET__CcGYAxBH__"